module.exports = "https://static.energy5.com/_next/static/images/battery-b7d6bc787f47f0e43339f4a5aeec18f6.webp";